<!-- 拍机堂品牌映射 -->
<template>
    <div>
        <h2 style="color: #fff">品牌映射</h2>
        <div class="form-group">
            <!-- 筛选菜单栏 -->
            <div>
                <el-form :inline="true" :model="formBrandData">
                    <!-- 平台 -->
                    <el-form-item label="">
                        <el-select v-model="formBrandData.sources" clearable placeholder="平台">
                            <el-option v-for="item in platformList" :key="item.id" :label="item.paramValue" :value="item.paramValue" />
                        </el-select>
                    </el-form-item>
                    <!-- 平台的品牌 -->
                    <el-form-item label="">
                        <el-select v-model="formBrandData.otherBrandName" filterable remote clearable placeholder="平台的品牌">
                            <el-option v-for="item in platformBrandList" :key="item" :label="item" :value="item" />
                        </el-select>
                    </el-form-item>
                    <!-- 系统平台品牌 -->
                    <el-form-item label="">
                        <el-select v-model="formBrandData.productBrandName" clearable filterable remote placeholder="系统平台品牌">
                            <el-option v-for="item in sysBrandList" :key="item" :label="item" :value="item" />
                        </el-select>
                    </el-form-item>
                    <!-- 是否映射 -->
                    <el-form-item label="">
                        <el-select v-model="formBrandData.status" clearable placeholder="是否映射">
                            <el-option v-for="item in statusList" :key="item.key" :label="item.key" :value="item.value" />
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="getBrandMappingList()">查询</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <!-- 数据展示 -->
            <el-table :data="BrandMappingList">
                <!-- 外部平台 -->
                <el-table-column label="平台" min-width="200px">
                    <template #default="scope">
                        {{ scope.row.sources }}
                    </template>
                </el-table-column>
                <!-- 外部型号 -->
                <el-table-column label="其他平台品牌" min-width="200px">
                    <template #default="scope">
                        {{ scope.row.otherPlatformName }}
                    </template>
                </el-table-column>
                <!-- 系统型号 -->
                <el-table-column label="系统平台品牌" min-width="200px">
                    <template #default="scope">
                        {{ scope.row.productBrandName }}
                    </template>
                </el-table-column>
                <!-- 操作列 -->
                <el-table-column label="操作" header-align="center" align="center" min-width="200px">
                    <template v-slot="scope">
                        <el-button type="success" @click="showBrandAddDialog(scope.row)" v-if="!scope.row.productBrandName">添加映射</el-button>
                        <el-button type="success" @click="showBrandEditDialog(scope.row)" v-if="scope.row.productBrandName"> 编辑</el-button>
                        <el-button type="danger" @click="handleBrandMappingDelete(scope.row)"> 删除 </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 页码栏 -->
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                v-model:current-page="currentPage"
                :page-sizes="[10, 20, 30, 40]"
                v-model:page-size="itemsPerBrandPage"
                layout="total, sizes, prev, pager, next, jumper"
                :total="allPagesBrand" />
        </div>
        <!-- 弹窗修改 -->
        <el-dialog v-model="isBrandDialogVisible" :title="currentBrandMapping.editId == undefined ? '新增品牌映射' : '修改品牌映射'">
            <el-form :model="currentBrandMapping" :rules="rules" ref="formRef" label-width="120px">
                <el-row>
                    <el-col :span="12">
                        <div style="margin: 0 0 10px 20px">{{ brandMappingmName }}</div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="系统标准品牌" prop="productBrandId">
                            <el-select v-model="currentBrandMapping.productBrandId" clearable filterable remote @change="selectBrandChange" placeholder="请选择">
                                <el-option v-for="item in addSysBrandList" :key="item.id" :label="item.brandName" :value="item.id" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <template v-slot:footer>
                <div class="dialog-footer">
                    <el-button @click="isBrandDialogVisible = false">取消</el-button>
                    <el-button type="primary" @click="saveBrandMapping">保存</el-button>
                </div>
            </template>
        </el-dialog>
    </div>
</template>

<script>
    import FixedButtons from "@/components/FixedButtons.vue";
    import axios from "axios";

    export default {
        name: "brandcheckView",
        components: { FixedButtons },
        data() {
            return {
                props: { multiple: true, label: "paramValue", value: "看后端传来的" },

                //查询各平台
                platformURL: "/api/systemConfig/queryBySystemConfigSearchDTO",

                // 查询各平台的品牌
                platformBrand: "/api/ProductBrandMapping/init",

                // 查询系统品牌
                sysBrand: "/api/ProductBrand/init",

                // 新增时候系统品牌查询
                addSysBrand: "/api/ProductBrand/queryDataByParam",

                // 分页查询其他平台品牌映射到系统品牌数据
                productBrandMapping: "/api/ProductBrandMapping/queryDataByParam",

                // 添加品牌映射关系
                addBrandMapping: "/api/ProductBrandMapping/insertBrandMapping",

                // 编辑品牌映射关系
                editBrandMapping: "/api/ProductBrandMapping/update",

                // 删除品牌映射关系
                deleteBrandMapping: "/api/ProductBrandMapping/deleteBrandMapping",

                //分页查询其他平台机型映射到系统机型数据
                correspondence: "/api/ProductModelMapping/queryModelMappingDataByParam",

                // 添加型号映射关系
                addMapping: "/api/ProductModelMapping/insertModelMapping",

                // 编辑型号映射关系
                editMapping: "/api/ProductModelMapping/update",

                // 删除型号映射关系
                deleteMapping: "/api/ProductModelMapping/deleteModelMapping",

                // 查询平台和机型映射初始化下拉框
                platformModelMapping: "/api/ProductModelMapping/init",

                // 查询系统标准的品牌和机型初始化下拉框
                syspStandardModel: "/api/ProductModel/init",

                // 系统标准型号
                sysModel: "/api/ProductModel/queryDataByParam",

                // 查询瑕疵数据
                flawData: "/api/PlatformDesc/queryDataByParam",

                // 查询瑕疵数据
                flawData: "/api/PlatformDesc/queryDataByParam",

                // 查询下拉框检索数据
                flawSearch: "/api/PlatformDesc/init",

                // 查询下拉框检索数据
                sysStandardFlaw: "/api/PjtDamageStandards/init",

                // 新增瑕疵映射
                addFlawMapping: "/api/PlatformDescReflect/insert",

                // 修改瑕疵映射
                editFlawMapping: "/api/PlatformDescReflect/update",

                // 删除瑕疵映射
                deleteFlawMapping: "/api/PlatformDescReflect/delete",

                // 当前页码
                currentPage: 1,
                // 默认每页显示条目数
                itemsPerPage: 10,
                itemsPerBrandPage: 10,
                itemsPerModelPage: 10,
                itemsPerFlawPage: 10,
                // 总页数
                allPagesBrand: 1,
                allPagesmodel: 1,
                allPagesFlaw: 1,

                BrandReflectShow: true,
                modelReflectShow: false,
                damageReflectShow: false,

                activeName: "first",

                formBrandData: {
                    otherBrandName: "", // 其他平台型号
                    productBrandName: "", // 系统型号
                    sources: "", // 平台
                    status: "", // 是否映射
                },
                platformBrandList: [], //平台品牌
                sysBrandList: [], // 系统品牌
                addSysBrandList: [], // 添加时候的系统品牌
                isBrandDialogVisible: false, //新增编辑弹框
                // brandId: '', //新增id
                // productBrandId: '', //新增品牌id
                brandMappingmName: "",
                currentBrandMapping: {
                    editId: undefined,
                    id: "",
                    productBrandId: "",
                    brandName: "",
                },
                BrandMappingList: [], //其他平台映射系统平台列表

                formData: {
                    brandId: "", //系统品牌id
                    otherModelName: "", // 其他平台型号
                    productModelName: "", // 系统型号
                    sources: "", // 平台
                    status: "", // 是否映射
                },
                statusList: [
                    { key: "已映射", value: "0" },
                    { key: "未映射", value: "1" },
                ],
                platformList: [], // 平台信息
                correspondenceList: [], // 对应信息
                sysPlatformBrandList: [], //系统平台品牌
                sysPlatformModelList: [], //系统平台型号
                otherPlatformModelList: [], // 其他平台型号
                sources: "", //平台
                brandId: "",
                isBrandId: "", //系统平台品牌是否映射过
                isBrandName: "",
                isDialogVisible: false, //新增编辑弹框
                sysModelList: [], // 系统标准型号列表
                otherPlatformName: "",
                currentMapping: {
                    editId: undefined,
                    id: "",
                    brandId: "",
                    productModelId: "",
                    modelName: "",
                    editProductModelId: "",
                },

                formFlawData: {
                    descLevel1: "", //一级瑕疵
                    descLevel2: "", // 二级瑕疵
                    standardsKeyWord: "", // 系统瑕疵
                    sources: "", // 平台
                    status: "", // 是否映射
                },
                flawDataList: [], // 瑕疵映射列表
                flawOneLevelList: [], //一级瑕疵
                flawTwoLevelList: [], //二级瑕疵
                sysStandardFlawListOne: [], //系统一级瑕疵数据
                sysStandardFlawListTwo: [], //系统二级瑕疵数据
                sysStandardFlawListThree: [], //系统三级瑕疵数据
                isFlawDialogVisible: false, //瑕疵弹框
                currentFlawMapping: {
                    editId: undefined,
                    id: "",
                    sdandardsLevel1: "", //一级名字
                    sdandardsLevel2: "", //二级名字
                    sdandardsLevel3: "", //三级名字
                    otherPlatformDescId: "",
                    pjtDescId: "",
                },
                otherPlatformNameFlaw: "",

                rules: {
                    modelName: [{ required: true, message: "系统标准型号不能为空", trigger: "blur" }],
                },
            };
        },
        created() {
            this.nickName = localStorage.getItem("nickname") || "";
            this.phone = localStorage.getItem("tel") || "";
            this.getPlatformList();
            this.getPlatformBrandList();
            this.getSysBrandList();
            this.getBrandMappingList();
        },
        methods: {
            // 查询平台
            getPlatformList() {
                axios
                    .get(this.platformURL, {
                        headers: {
                            satoken: localStorage.sa,
                        },
                        params: {
                            pageNo: this.currentPage,
                            pageSize: this.itemsPerPage,
                            // paramKey: "USER_VISIBLE_PLATFORM_NAME",
                        },
                    })
                    .then((res) => {
                        this.platformList = res.data.data.result;
                    })
                    .catch((error) => {
                        this.data = error;
                        console.error("获取数据出错:", error);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },

            // 查询平台品牌
            getPlatformBrandList() {
                axios
                    .get(this.platformBrand, {
                        headers: {
                            satoken: localStorage.sa,
                        },
                        params: {
                            pageNo: this.currentPage,
                            pageSize: this.itemsPerBrandPage,
                            // paramKey: "USER_VISIBLE_PLATFORM_NAME",
                        },
                    })
                    .then((res) => {
                        this.platformBrandList = res.data.data.otherPlatformNameList;
                    })
                    .catch((error) => {
                        this.data = error;
                        console.error("获取数据出错:", error);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },

            //查询系统品牌
            getSysBrandList() {
                axios
                    .get(this.sysBrand, {
                        headers: {
                            satoken: localStorage.sa,
                        },
                        params: {
                            pageNo: this.currentPage,
                            pageSize: this.itemsPerBrandPage,
                            // paramKey: "USER_VISIBLE_PLATFORM_NAME",
                        },
                    })
                    .then((res) => {
                        this.sysBrandList = res.data.data.brandNameList;
                    })
                    .catch((error) => {
                        this.data = error;
                        console.error("获取数据出错:", error);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },

            //新增系统品牌查询
            getAddSysBrandList() {
                axios
                    .get(this.addSysBrand, {
                        headers: {
                            satoken: localStorage.sa,
                        },
                        params: {
                            pageNo: this.currentPage,
                            pageSize: this.itemsPerBrandPage,
                            // paramKey: "USER_VISIBLE_PLATFORM_NAME",
                        },
                    })
                    .then((res) => {
                        this.addSysBrandList = res.data.data;
                    })
                    .catch((error) => {
                        this.data = error;
                        console.error("获取数据出错:", error);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },
            selectBrandChange(value) {
                this.currentBrandMapping.productBrandId = value;
            },

            // 新增品牌映射关系
            showBrandAddDialog(row) {
                // currentBrandMapping: {
                //     editId: undefined,
                //     id: "",
                //     productBrandId: "",
                // },
                // brandId: '', //新增id
                // productBrandId: '', //新增品牌id

                this.isBrandDialogVisible = true;
                this.brandMappingmName = row.otherPlatformName;
                this.currentBrandMapping.editId = undefined;
                this.currentBrandMapping.id = row.id;
                this.currentBrandMapping.productBrandId = "";
                this.currentBrandMapping.brandName = "";
                this.getAddSysBrandList();
            },

            // 编辑品牌映射
            showBrandEditDialog(row) {
                this.isBrandDialogVisible = true;
                this.currentBrandMapping.editId = row.id;
                this.currentBrandMapping.id = row.id;
                this.currentBrandMapping.productBrandId = row.productBrandId;
                this.currentBrandMapping.brandName = row.productBrandName;

                this.getAddSysBrandList();
            },

            // 新增保存and编辑保存
            saveBrandMapping() {
                this.$refs.formRef.validate((valid) => {
                    if (valid) {
                        if (this.currentBrandMapping.editId === undefined) {
                            const body = {
                                id: this.currentBrandMapping.id,
                                productBrandId: this.currentBrandMapping.productBrandId,
                            };
                            axios
                                .post(this.addBrandMapping, body, {
                                    headers: {
                                        satoken: localStorage.sa,
                                        "Content-Type": "application/json",
                                    },
                                })
                                .then((res) => {
                                    if (res.data.code === 200) {
                                        this.$message({
                                            message: res.data.message,
                                            type: "success",
                                        });
                                        this.isBrandDialogVisible = false;
                                        this.getBrandMappingList();
                                    } else {
                                        this.$message({
                                            message: res.data.message,
                                            type: "error",
                                        });
                                    }
                                })
                                .catch((error) => {
                                    // 处理错误
                                    console.error("新增失败", error);
                                });
                        } else {
                            const body = {
                                id: this.currentBrandMapping.id,
                                productBrandId: this.currentBrandMapping.productBrandId,
                            };
                            axios
                                .put(this.editBrandMapping, body, {
                                    headers: {
                                        satoken: localStorage.sa,
                                        "Content-Type": "application/json",
                                    },
                                })
                                .then((res) => {
                                    if (res.data.code === 200) {
                                        this.$message({
                                            message: res.data.message,
                                            type: "success",
                                        });
                                        this.isBrandDialogVisible = false;
                                        this.getBrandMappingList();
                                        this.currentBrandMapping.productBrandId = "";
                                    } else {
                                        this.$message({
                                            message: res.data.message,
                                            type: "error",
                                        });
                                    }
                                })
                                .catch((error) => {
                                    // 处理错误
                                    console.error("新增失败", error);
                                });
                        }
                    }
                });
            },

            // 删除品牌映射
            handleBrandMappingDelete(row) {
                try {
                    this.$confirm("确认删除当前映射吗?", "提示", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                        .then(() => {
                            axios
                                .delete(this.deleteBrandMapping + `?idList=${row.id}`, {
                                    headers: {
                                        satoken: localStorage.sa,
                                        "Content-Type": "application/json",
                                    },
                                })
                                .then((res) => {
                                    if (res.data.code === 200) {
                                        this.$message({
                                            message: res.data.message,
                                            type: "success",
                                        });
                                        this.getBrandMappingList();
                                    } else {
                                        this.$message.error(res.data.data);
                                    }
                                })
                                .catch((error) => {
                                    // 处理错误
                                    console.error("删除失败", error);
                                });
                        })
                        .catch(() => {
                            this.$message({
                                type: "info",
                                message: "已取消删除",
                            });
                        });
                } catch (error) {
                    console.error("Failed to delete user:", error);
                }
            },

            // 品牌映射关系列表
            getBrandMappingList() {
                axios
                    .get(this.productBrandMapping, {
                        headers: {
                            satoken: localStorage.sa,
                        },
                        params: {
                            pageNo: this.currentPage,
                            pageSize: this.itemsPerBrandPage,
                            ...this.formBrandData,
                        },
                    })
                    .then((res) => {
                        this.allPagesBrand = res.data.data.total;
                        this.BrandMappingList = res.data.data.result;
                    })
                    .catch((error) => {
                        this.data = error;
                        console.error("获取数据出错:", error);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },

            // 改变条数
            handleSizeChange(val) {
                this.itemsPerBrandPage = val;
                this.getBrandMappingList();
            },

            //改变页数
            handleCurrentChange(val) {
                this.currentPage = val;
                this.getBrandMappingList();
            },
        },
        watch: {},
        computed: {},
        mounted() {},
    };
</script>

<style lang="scss" scoped></style>
